import React, { useEffect, useState } from "react";
import DrawerTitle from "../Drawer/DrawerTitle";
import {
  AllTabType,
  IAppintentType,
  IqueryParams,
} from "src/types/GlobalInterfaces";
import AppointmentCard from "../Cards/AppointmentCard";
import { IPaginated } from "src/types/paginated";
import { toast } from "react-toastify";
import httpRequest from "src/helpers/httpRequest";
import qs from "qs";
import PaginationWrapper from "../WebsiteComponents/PaginationWrapper";
import moment from "moment";
import { ImageBaseUrl } from "src/lib/constans";
import { capitalize } from "@mui/material";
import NoItemUI from "../NoItemUI";
import { useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import InfinteScrollWrapper from "../GlobalComponents/Widget/InfinteScrollWrapper";

interface IProps {
  onBack: () => void;
  setActiveTab: (tab: AllTabType) => void;
  setCurrentDoctor: (doctor: any) => void;
  onClose?: () => void;
}

interface IDoctorList {
  _id: string;
  firstName: string;
  lastName: string;
  isOnlineAppoinment: boolean;
  hospitalName: null | string;
  appoinmentDate: string;
}

interface IMyDoctorResponse {
  documents: IDoctorList[];
  paginated: IPaginated;
}

const MyDoctorsScreen: React.FC<IProps> = ({
  onBack,
  setActiveTab,
  setCurrentDoctor,
  onClose,
}) => {
  const [myDoctors, setMyDoctors] = useState<IAppintentType[]>([]);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  }); // Handles pagination state
  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 10,
    startDate: "",
    endDate: "",
  }); // Query parameters for API request
  const { latestChat } = useSelector((state: RootState) => state.chat);
  // Handles page change in pagination
  const handlePageChange = (e: number) => {
    setQueryParams((prev) => ({
      ...prev,
      page: e,
    }));
  };

  // API_CALL: Function to fetch the list of my doctors
  const fetchMyDoctorList = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IMyDoctorResponse>({
      path: `/appoiment/all/doctor?${qs.stringify(queryParams)}`,
    });
    if (res) {
      const { documents = [], paginated } = res;
      setMyDoctors(
        documents.map((item: any) => {
          let dat: IAppintentType = {
            id: item?._id,
            status: item?.status,
            name:
              capitalize(item?.firstName || "") +
              " " +
              capitalize(item?.lastName || ""),
            rating: 4,
            fee: Number(item?.fees),
            date: moment(item?.appoinmentDate).format("DD-MM-YYYY"),
            image: item?.coverPhoto,
            specialty: item?.specializations,
            qualification: item?.education?.join(", "),
            redNotified: item?.redNotified,
          };
          return dat;
        })
      );
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" }); // Show error toast if API call fails
    }
    setIsLoader(false);
  };

  useEffect(() => {
    fetchMyDoctorList();
  }, [queryParams]);

  return (
    <>
      <DrawerTitle
        title="My Doctors"
        onBack={onBack}
        backBtn
        id={"back-button"}
      />
      <div className="w-full side-bar-padding-3">
        <InfinteScrollWrapper
          isLoading={isLoader}
          isLoadButton={true}
          noDataOptions={{
            text2: "No Doctors Found",
          }}
          onLoadMore={(page) => {
            setQueryParams((prev) => ({ ...prev, page: page }));
          }}
          length={myDoctors.length}
          currentPage={queryParams?.page}
          totalPages={paginated?.totalPages}
        >
          {myDoctors.map((doctor, index) => (
            <AppointmentCard
              id={`manage-${index}`}
              key={doctor.id}
              doctor={doctor}
              type="my-doctor"
              onViewDetails={() => {
                setCurrentDoctor(doctor);
                setActiveTab("ManageDoctor");
              }}
              unread={doctor.redNotified === false ? 1 : latestChat?.find((item) => item?._id === doctor.id)?.unRead || 0}
              isOnline={
                latestChat?.find((item) => item?._id === doctor.id)
                  ?.statusOnline || false
              }
            />
          ))}
        </InfinteScrollWrapper>
      </div>
    </>
  );
};

export default MyDoctorsScreen;
